export default __webpack_public_path__ + "d9b392ddb6b9040c3c6643138c58b077.svg";